<div class="btn-group" ngbDropdown role="group">
  <button class="btn btn-outline-success" ngbDropdownToggle>{{ 'ord.order-invoice-doc.btn.print' | transloco }}</button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem (click)="printInvoice('payment')">{{ 'ord.order-invoice-doc.btn.invoicePayment' | transloco }}</button>
    <button ngbDropdownItem (click)="printInvoice('product')">{{ 'ord.order-invoice-doc.btn.invoiceRelease' | transloco }}</button>
    <button ngbDropdownItem (click)="printInvoice('service')">{{ 'ord.order-invoice-doc.btn.certificate' | transloco }}</button>
  </div>
</div>
